export default "__VITE_ASSET__4ec5ac7c__"